import React from 'react';
import PropTypes from 'prop-types';
import t, { Trans, format } from 'translations';

export default function ContactInfo({ tabIndex }) {
    return (
        <article className="contact-info">
            <h1 className="contact-info--title u-reset"><Trans path="contact.title"/></h1>
            <p className="contact-info--link">
                <a className="u-reset" tabIndex={tabIndex} href={`mailto:${ t('amigos.mails.info') }`}><Trans
                    path="amigos.mails.info"/></a>
            </p>
            <div className="contact-info--text"
                dangerouslySetInnerHTML={{ __html: format('contact.text') }}/>
        </article>
    );
};

ContactInfo.propTypes = {
    tabIndex: PropTypes.number.isRequired,
};

ContactInfo.defaultProps = {
    tabIndex: 0,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/contact-info/index.js